import { render, staticRenderFns } from "./orderpaysuccee.vue?vue&type=template&id=331a5104&scoped=true&"
import script from "./orderpaysuccee.vue?vue&type=script&lang=js&"
export * from "./orderpaysuccee.vue?vue&type=script&lang=js&"
import style0 from "./orderpaysuccee.vue?vue&type=style&index=0&id=331a5104&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331a5104",
  null
  
)

export default component.exports